import React, { useState } from 'react';
import { Modal, Input } from 'antd';

import background_circle_blue_modal from 'images/background_circle_blue_modal.svg';
import icon_plus_white from 'images/icon_plus_white.svg';
import TextArea from 'antd/lib/input/TextArea';



import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';



const AddGlossaryTerm = (props) => {

    const [value, setValue] = useState('');

    const valueOnChange = (e)=>{
        setValue(e)
        // props.handleChangeInputAddGlossaryTermDescription(e)
    }
    console.log(`value`, value)


    return (
        <>
            <Modal
                className="basic-modal add-term-modal"
                title=""
                visible={props.addGlossaryTermModalIsVisible}
                onOk={() => {
                    props.handleOkAddGlossaryTerm();
                }}
                onCancel={() => {
                    props.handleCanceladdGlossaryTerm();
                }}
                footer={null}
                closable={false}
                bodyStyle={{ height: 550 }}
                width={470}
            >
                <div className="icon-container">
                    <img
                        className="img-icon-container"
                        src={background_circle_blue_modal}
                    />
                    <img
                        style={{ height: '30px', right: 20, top: 25 }}
                        className="icon-in-green-circle"
                        src={icon_plus_white}
                    />
                </div>
                <div>
                    <div style={{ padding: '8px 0 0 0', marginLeft: 6 }}>
                        <p className="header-title">Add Term</p>
                        <p
                            className="p-desctiption"
                            style={{ marginBottom: '40px' }}
                        >
                            Type the name of the term and description <br />
                            then confirm by clicking "Create"
                        </p>
                    </div>
                    <div>
                        <Input
                            placeholder="Glossary Term"
                            onChange={props.handleChangeInputAddGlossaryTerm}
                            style={{ marginBottom: 5 }}
                        ></Input>
                        {/* <TextArea
                            placeholder="Term Definition"
                            onChange={
                                props.handleChangeInputAddGlossaryTermDescription
                            }
                            style={{
                                marginBottom: 5,
                                border: '1px solid #d9d9d9!important',
                                borderRadius: 0
                            }}
                        ></TextArea> */}
                    </div>

                    {/* <ReactQuill theme="snow" value={value} onChange={(e)=>{valueOnChange(e)}} /> */}
                    <ReactQuill theme="snow" value={props.glossaryTermDescription} onChange={(e)=>{props.handleChangeInputAddGlossaryTermDescription(e)}} />
                    <div>
                        <button
                            className="ant-btn ant-btn-primary ant-btn-block blue-button"
                            onClick={props.handleOkAddGlossaryTerm}
                            style={{ width: '100%', marginTop: '30px' }}
                        >
                            CREATE
                        </button>
                    </div>
                    <button
                        onClick={props.handleCanceladdGlossaryTerm}
                        style={{
                            width: '100%',
                            marginTop: 10,
                            color: '#407CB1',
                            height: '26px',
                            backgroundColor: '#fff',
                            border: '1px solid #578CBA'
                        }}
                    >
                        CANCEL
                    </button>
                </div>
            </Modal>
        </>
    );
};

export default AddGlossaryTerm;
